export default __webpack_public_path__ + "static/media/baskets.91229da1.jpeg";